<template>
    <a :href="url">
        {{label}}
        <em class="fas fa-location-arrow "></em>
    </a>
</template>

<script lang="ts">
    import { ref } from "vue";
    import { getDrivingDirections } from "../helpers/locationHelpers"

    export default {
        name: 'GoogleMapDrivingDirectionLink',
        props: {
            label: {
                type: String,
                required: true
            },
            origin: {
                type: Object,
                required: false
            },
            destination: {
                type: Object,
                required: true
            },
        },
        setup(props) {
            let url = ref("")

            getDrivingDirections(props.destination, props.origin).then((res: string) => {
                url.value = res
            }) 

            return {url}
        },
    };
</script>

<style lang="scss" scoped></style>